/**
 * SectionKicker — el «· etiqueta ámbar · línea que llega hasta el borde ·» con
 * el que abre casi toda sección del rediseño.
 *
 * Existe porque en el diseño se repite catorce veces entre las once páginas, y
 * cada copia trae sus propios `font-size: 12.5px` y `height: 1px` a mano. Una
 * sola definición evita que la decimoquinta salga a 13 px y nadie lo note.
 *
 * `insignia` es el badge verde de «Nuevo» que llevan un par de secciones.
 */
export default function SectionKicker({ children, insignia }) {
  return (
    <div className="flex items-center gap-3">
      <span className="v3-kicker">{children}</span>
      {insignia ? (
        <span className="text-[11px] font-bold text-white bg-v3-green rounded-full px-2.5 py-1">
          {insignia}
        </span>
      ) : null}
      {/* Decorativo: una regla que separa, no una lista ni un encabezado. Va
          como <span> vacío y no como <hr> para que no salga en el árbol de
          accesibilidad. */}
      <span className="flex-1 h-px bg-v3-line" aria-hidden="true" />
    </div>
  );
}
